<template>
	<div class="tasks-page"> 
		<div class="actionBar d-flex">
			<div class="row d-flex">
				<div class="btn-group btn-group-toggle mr-3" data-toggle="buttons">
					<label
						v-for="(option, index) in tabs.tabStyle"
						:key="option.name"
						class="btn btn-sm btn-primary btn-simple"
						:class="{ active: tabs.activeIndexStyle === index }"
						:id="index"
					>
						<input
							type="radio"
							@click="initTabStyle(index)"
							name="options"
							autocomplete="off"
							:checked="tabs.activeIndexStyle === index"
						/>
						<span class="d-none d-sm-block">{{ option.name }}</span>
						<span class="d-block d-sm-none">
							<i :class="option.icon"></i>
						</span>
					</label>
				</div>
				<div class="filterbutton filter-tag-row">
					<ReFilterBtn v-model="bShowFilter" :masExcl="['ts','rb_service','pending','overdue']" :bShowOptsCount="false"/>
					<span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary" v-if="tabs.activeIndexStyle!=1 && tabs.activeIndexStyle!=2" >Объектов найдено: {{masTasks.length}}</span>
				</div>
			</div>
			
		</div>
		
		<div class="col-lg-6 mt-2" v-show="bShowFilter">
			<ReFilter
				:masAllFilterParams="masAllFilterParams"
				v-model="objGetParams"
				v-on:filterapply="OnFilterApply"
				name="tasks"
			/>
		</div>

		<card class="mt-3" 
			v-loading.fullscreen.lock="$GVO.fullscreenLoading"
			element-loading-text="Загрузка данных..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)"	
		>
			<ReDoska v-if="tabs.activeIndexStyle==0"  :masTasks="masTasks" v-on:loadmore="onLoadMore" :bShowOverdue="bShowOverdue" :bShowCurrent="bShowCurrent" :bShowNext="bShowNext"/>
			<ReList  v-if="tabs.activeIndexStyle==1"  :masTasks="refurbushedMasTasks"  v-on:loadmore="onLoadMore" :bShowList="bShowList"/>
			<ReKanban  v-if="tabs.activeIndexStyle==2" :masKanban="masKanban"/>
			<ReCalendar
				v-if="tabs.activeIndexStyle==3 || tabs.activeIndexStyle==4 || tabs.activeIndexStyle==5"
				:masTasks="masTasks"
				:strCalendarView="strCalendarView"
				@prev="onPrevCalendar" @next="onNextCalendar"
			/>
		</card>
	</div>
</template>
<script>
import { eventEmitter } from "src/plugins/globalComponents.js";
import ReFilter from "src/our_components/FilterPrinter/ReFilter.vue";
import ReFilterBtn from "src/our_components/FilterPrinter/ReFilterBtn.vue";
import ReCalendar from "src/our_components/TasksView/ReCalendar.vue";
import ReDoska from "src/our_components/TasksView/ReDoska.vue";
import ReList from "src/our_components/TasksView/ReList.vue";
import ReKanban from "src/our_components/TasksView/ReKanban.vue";
import moment from 'moment';
// import VueMoment from 'vue-moment';

export default {
	name: "tasks-page",
	components: {
		ReFilter,
		ReFilterBtn,
		ReCalendar,
		ReList,
		ReDoska,
		ReKanban
	},	
	data() {
		return {
			tabs: {
				activeIndexStyle: 0,
				tabStyle: [
					{ name: "Доска", icon: "d-inline-block tim-ic ic-doska" },
					{ name: "Список", icon: "tim-icons icon-align-left-2" },
					{ name: "Канбан", icon: "tim-icons tim-ic ic-kanban"},
					
					{ name: "День", icon: "d-inline-block tim-ic ic-calendar-day" },
					{ name: "Неделя", icon: "d-inline-block tim-ic ic-calendar-week" },
					{ name: "Месяц", icon: "d-inline-block tim-ic ic-calendar-month" }
					
				],
				activeIndexView: 1,
				tabView: [
					{ name: "Все", icon: "d-inline-block tim-ic ic-group" },
					{ name: "Мои", icon: "tim-icons icon-user-run" },
					{ name: "Сотрудник", icon: "tim-icons icon-single-02" }
				]
			},
			bShowFilter: false,
			objGetParams: {},
			masAllFilterParams: this.currentFilterConfig(),
			masKanban: [],
			masTasks: [],
			refurbushedMasTasks:{},
			bIsLoading: true,
			bIsGeted: false,
			cat_timer: null,
			fullscreenLoading: false,
			iOverdue_p:1,
			iCurrent_p:1,
			iNext_p:1,
			iList_p:1,
			bShowOverdue:true,
			bShowCurrent:true,
			bShowNext:true,
			bShowList:true,
			masCalendarMonth:[],
			masObjects_total:0,
		};
	},
	computed: {
		strCalendarView: function() {
			if (this.tabs.activeIndexStyle == 3) {
				return "timeGridDay";
			} else if (this.tabs.activeIndexStyle == 4) {
				return "timeGridWeek";
			}
			return "dayGridMonth"; //'dayGridMonth' || 'timeGridDay' || 'timeGridWeek'
		}
	},
	methods: {
		getTasks(bIsChPage=false,objPageFilterParams={}) {
			//console.log('getTasks');
			this.objGetParams = this.$GVO.GetAllGet();
			//if(typeof this.objGetParams.pending == 'undefined') this.objGetParams['pending'] = true;
			//if(typeof this.objGetParams.overdue == 'undefined') this.objGetParams['overdue'] = true;
			let filter = {};
			let c2p = 50;
			if(typeof this.objGetParams.c2p != 'undefined'){c2p = this.objGetParams.c2p;}
			if(typeof objPageFilterParams.c2p != 'undefined'){c2p = objPageFilterParams.c2p;}
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				filter = this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams));
				for (const key in filter) {
					if(filter[key] == 'true' || filter[key] == true) filter[key] = 1;
					if(filter[key] == 'false' || filter[key] == false) filter[key] = 0;
				}
			}

			if(typeof this.$GVO.my_profile.code != 'undefined' && !this.bIsGeted){
				if(typeof filter.agent_id == 'undefined' || filter.agent_id == '') {
					//filter.agent_id = this.$GVO.my_profile.code;
					filter.agent_id = 'my_under';
				}
				//console.log('getTasks',filter);
				this.bIsGeted = true;
				//this.openFullScreen1();
				this.$GVO.ApiCall('GET_TASKS_BY_AGENT',{obj:'services',flt:{...{list:true}, ...filter, ...objPageFilterParams, ...{'c2p':c2p}}})
					.then((objApi) => {
						//console.log('GET_TASKS_BY_AGENT',objApi);
						if(objApi.success && objApi.data.length>0){	
							if(bIsChPage){
								for (let i = 0; i < objApi.data.length; i++) {
									if(this.masTasks.find(obj => obj.id === objApi.data[i].id)){

									}else{
										//console.log('getTasks - append');
										this.masTasks.push(objApi.data[i]);
									}
								}
								//this.masTasks = [...this.masTasks,...objApi.data];
								if (typeof objPageFilterParams.DEADLINE_LESS != 'undefined' && typeof objPageFilterParams.p != 'undefined') {
									if(objApi.data.length < 50) this.bShowOverdue = false; else this.bShowOverdue = true;
									this.iOverdue_p++;
								} else if(typeof objPageFilterParams.STARTDATE_LESS != 'undefined' && typeof objPageFilterParams.p != 'undefined'){
									if(objApi.data.length < 50) this.bShowCurrent = false; else this.bShowCurrent = true;
									this.iCurrent_p++;
								} else if(typeof objPageFilterParams.STARTDATE_MORE != 'undefined' && typeof objPageFilterParams.p != 'undefined'){
									if(objApi.data.length < 50) this.bShowNext = false; else this.bShowNext = true;
									this.iNext_p++;
								}
							}else{
								this.masTasks = objApi.data;
							}
						}
						//console.log('this.masTasks',this.masTasks);
						this.bIsLoading = false;
					})
					.catch(errorObjApi => {console.error(errorObjApi); this.bIsLoading = false;});
			}
		},
		getKanban(){
			//console.log('getKanban');
			this.objGetParams = this.$GVO.GetAllGet();
			if(typeof this.objGetParams.pending == 'undefined') this.objGetParams['pending'] = true;
			if(typeof this.objGetParams.overdue == 'undefined') this.objGetParams['overdue'] = true;
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				filter = this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams));
				for (const key in filter) {
					if(filter[key] == 'true' || filter[key] == true) filter[key] = 1;
					if(filter[key] == 'false' || filter[key] == false) filter[key] = 0;
				}
			}
			//console.log('getKanban',filter);
			this.$GVO.ApiCall('GET_SERVICE_ANAL',{obj:'services',flt:{...filter}})
			.then((objApi) => { 
				//console.log(objApi);
				if(objApi.success === true){
					this.masKanban = objApi.data;
					//this.masTasks = this.masKanban.tasks;
				}else{
					this.masKanban = [];
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		groupByDate(bIsChPage=false,objPageFilterParams={}){
			this.objGetParams = this.$GVO.GetAllGet();
			//if(typeof this.objGetParams.pending == 'undefined') this.objGetParams['pending'] = true;
			//if(typeof this.objGetParams.overdue == 'undefined') this.objGetParams['overdue'] = true;
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				filter = this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams));
				for (const key in filter) {
					if(filter[key] == 'true' || filter[key] == true) filter[key] = 1;
					if(filter[key] == 'false' || filter[key] == false) filter[key] = 0;
				}
			}
			if(typeof this.$GVO.my_profile.code != 'undefined' && !this.bIsGeted){
				if(typeof filter.agent_id == 'undefined' || filter.agent_id == '') {
					//filter.agent_id = this.$GVO.my_profile.code;
					filter.agent_id = 'my_under';
				}
				//console.log('getTasks',filter);
				this.bIsGeted = true;
				//this.openFullScreen1();
				/*
				if(bIsChPage){
					if (typeof objPageFilterParams.p != 'undefined') {
						this.iList_p++;
					}
				}
				*/
				let objP = {};
				if (typeof objPageFilterParams.p != 'undefined') {
					objP = {p:objPageFilterParams.p};
				}
				this.$GVO.ApiCall('GET_TASKS_BY_AGENT_DATELIST',{obj:'services',flt:{...{list:true}, ...filter, ...objP}})
					.then((objApi) => {
						//console.log(objApi);
						if(objApi.success && (Object.keys(objApi.data).length>0)){
							this.bShowList = true;
							if(bIsChPage){
								this.refurbushedMasTasks = {...this.refurbushedMasTasks, ...objApi.data};
								if (typeof objPageFilterParams.p != 'undefined') {
									this.iList_p++;
								}
							}else{
								this.refurbushedMasTasks = objApi.data;
							}
						}else{
							this.bShowList = false;
						}
						this.bIsLoading = false;
					})
					.catch(errorObjApi => {console.error(errorObjApi); this.bIsLoading = false;});
			}
		},
		initTabStyle(index) {
			this.tabs.activeIndexStyle = index;
			this.objGetParams['ts'] = this.tabs.activeIndexStyle;
			this.currentFilterConfig(this.tabs.activeIndexStyle);
			
			let url = new URL(location);
			url.searchParams.set('ts',index);
			this.$router.replace({path: url.search});
			//this.OnFilterApply();
		},
		initTabView(index) {
			this.tabs.activeIndexView = index;
		},
		setTabStyle(){
			this.objGetParams = this.$GVO.GetAllGet();
			
			if(typeof this.objGetParams['ts'] != 'undefined'){
				this.tabs.activeIndexStyle = parseInt(this.objGetParams['ts']);
				
			}else{
				this.tabs.activeIndexStyle = 0;
			}
		},
		currentFilterConfig(activeIndexStyle=0) {
			/*
			если при переходе по табам "слетает фильтр" то это тут. происходит потому что тыкая на таб - загружается конфиг с сервера и с дефолтными значениями применяется в фильтр. хоть что натыкай - пофиг, загружает дефолт.
			сделал костыть, отработает не всё. надо подумать как ГЕТ строку кошерно применить в фильтр после загрузки конфига. ИЛИ ВООБЩЕ этого не делать а сделать один фильтр.
			*/
			this.$GVO.ApiCall('GET_FILTER_TASKS',{obj:'services',flt:{'activeIndexStyle':activeIndexStyle}})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						this.objGetParams = this.$GVO.GetAllGet();
						for (let i = 0; i < objApi.config[0].elements.length; i++) {
							const element = objApi.config[0].elements[i];
							if(typeof this.objGetParams[element.elementGetParamMap] != 'undefined'){
								this.objGetParams[element.elementGetParamMap] = this.objGetParams[element.elementGetParamMap] == 'true'?true:this.objGetParams[element.elementGetParamMap] == 'false'?false:this.objGetParams[element.elementGetParamMap];
								objApi.config[0].elements[i].element_model = this.objGetParams[element.elementGetParamMap];
							}
						}
						this.masAllFilterParams = objApi.config;
						//console.log(this.$GVO.unlinkObject(this.masAllFilterParams));
						//console.log(this.$GVO.unlinkObject(this.objGetParams));
						eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);
						//this.OnFilterApply();
						return objApi.config;
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		OnFilterApply() {
			//this.objGetParams = data;
			//console.log('OnFilterApply',this.$GVO.unlinkObject(this.objGetParams));
			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] === '') delete this.objGetParams[key];
					if(key == 'rb_service') delete this.objGetParams[key];
				}
			}
			//console.log('OnFilterApply',this.$GVO.unlinkObject(this.objGetParams));
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log("OnFilterApply", strItogGetParams, this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit("OnFilterApply", this.objGetParams);
			this.reloadTasksAll();
		},
		AddTask(){
			this.$router.push({path: '/data/tasks/add'});
		},
		openFullScreen1(){
			this.fullscreenLoading = true;
			setTimeout(() => {
			this.fullscreenLoading = false;
			}, 2000);
		},
		onGetTasks(bIsChPage=false,objPageFilterParams={}){
			if(this.tabs.activeIndexStyle == 0){
				this.bIsGeted = false;
				this.getTasks(bIsChPage,objPageFilterParams);
			}
			if(this.tabs.activeIndexStyle == 1){
				this.bIsGeted = false;
				this.groupByDate(bIsChPage,objPageFilterParams);
			}
			if(this.tabs.activeIndexStyle == 2){
				this.getKanban();
			}
		},
		onLoadMore(strType){
			/*
			надо в апи сделать 4е параметра:
				DEADLINE_LESS
				DEADLINE_MORE
				STARTDATE_LESS
				STARTDATE_MORE
			описать по столбикам параметры так:
				просрочено: DEADLINE_LESS now() datetime
				сегодня: STARTDATE_LESS now() date 23:59:59
				завтра: STARTDATE_MORE now()+1d date 00:00:00
			*/
			let dateTomorrow = new Date();
			let dtNow = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
			let dNow = moment(new Date()).format('YYYY-MM-DD');
			let dTomorrow = new Date(dateTomorrow.setDate(dateTomorrow.getDate()+1)).toJSON().slice(0, 10);
			if(strType=='overdue'){
				this.onGetTasks(true,{'DEADLINE_LESS':dtNow,'p':this.iOverdue_p});
			} else if(strType=='current'){
				this.onGetTasks(true,{'STARTDATE_LESS':dNow+' 23:59:59','DEADLINE_MORE':dtNow,'p':this.iCurrent_p});
			} else if(strType=='next'){
				this.onGetTasks(true,{'STARTDATE_MORE':dTomorrow+' 00:00:00','DEADLINE_MORE':dtNow,'p':this.iNext_p});
			} else if(strType=='list'){
				this.onGetTasks(true,{'p':this.iList_p});
			}
		},
		getTasksAll(){
			if(this.tabs.activeIndexStyle == 0){
				this.onLoadMore('overdue');
				this.onLoadMore('current');
				this.onLoadMore('next');
			}
			if(this.tabs.activeIndexStyle == 1){
				this.onLoadMore('list');
			}
			if(this.tabs.activeIndexStyle == 2){
				this.onGetTasks();
			}
			if( this.tabs.activeIndexStyle == 3 || this.tabs.activeIndexStyle == 4 || this.tabs.activeIndexStyle == 5){
				this.bIsGeted = false;
				/*
				let objPageFilterParams = {};
				if(this.masCalendarMonth.length==0){
					this.masCalendarMonth.push(moment().subtract(2, 'months').format('MMYYYY'));
					this.masCalendarMonth.push(moment().subtract(1, 'months').format('MMYYYY'));
					this.masCalendarMonth.push(moment().format('MMYYYY'));

					let dMinus3Month = moment().subtract(2, 'months').format('YYYY-MM-DD');
					objPageFilterParams = {'STARTDATE_MORE':dMinus3Month+' 00:00:00'};
				}else{
					consolr.log('getTasksAll -> calendar -> else');
				}
				*/
				this.masCalendarMonth = [];  // надо придумать какой-то кэшь с данными и в нём передвигаться, и в него же догружать
				this.masCalendarMonth.push(moment().subtract(2, 'months').format('MMYYYY'));
				this.masCalendarMonth.push(moment().subtract(1, 'months').format('MMYYYY'));
				this.masCalendarMonth.push(moment().format('MMYYYY'));

				let dMinus3Month = moment().subtract(2, 'months').format('YYYY-MM-01');
				let objPageFilterParams = {'STARTDATE_MORE':dMinus3Month+' 00:00:00','c2p':1000};

				//console.log(objPageFilterParams);
				
				this.getTasks(false,objPageFilterParams);
			}
		},
		reloadTasksAll(){
			// console.log(ev);
			this.iOverdue_p=1;
			this.iCurrent_p=1;
			this.iNext_p=1;
			this.iList_p=1;
			this.masTasks = [];
			this.refurbushedMasTasks = {};
			this.getTasksAll();
		},
		onPrevCalendar(evtDate){
			//console.log("onPrevCalendar", evtDate);
			let pageMonth = moment(evtDate).subtract(1, 'months').format('MMYYYY');
			//console.log(pageMonth);
			if(this.masCalendarMonth.indexOf(pageMonth) == -1){
				this.masCalendarMonth.push(pageMonth);
				let dMinusMonth = moment(evtDate).subtract(1, 'months').format('YYYY-MM-DD');
				let dMonth = moment(evtDate).format('YYYY-MM-DD');
				let objPageFilterParams = {'STARTDATE_MORE':dMinusMonth+' 00:00:00','STARTDATE_LESS':dMonth+' 00:00:00','c2p':1000};
				//console.log('onPrevCalendar',objPageFilterParams);
				this.bIsGeted = false;
				this.getTasks(true,objPageFilterParams); // надо делать аппенд массива!!! возможно первое true это и делает - проверить
			}
		},
		onNextCalendar(evtDate){
			//console.log("onNextCalendar", evtDate);
			let pageMonth = moment(evtDate).add(1, 'months').format('MMYYYY');
			//console.log(pageMonth);
			if(this.masCalendarMonth.indexOf(pageMonth) == -1){
				//загружаем
			}
		},
		
	},
	mounted() {
		this.masCalendarMonth = [];		
	},
	created() {
		
		this.cat_timer = setInterval(() => {
			/*
			if(typeof this.$GVO.my_profile.code != 'undefined'){
				this.reloadTasksAll();
				clearTimeout(this.cat_timer);
				this.cat_timer = null;
			}
			*/
			eventEmitter.$on("reload_tasks", this.reloadTasksAll);
			clearTimeout(this.cat_timer);
		}, 250);
		
		this.objGetParams = this.$GVO.GetAllGet();
		this.setTabStyle();
		eventEmitter.$on("ResetFilter", this.ResetDopFilter);
		//eventEmitter.$on("reload_tasks", this.reloadTasksAll);
	},
	beforeDestroy() {
		// Отписываемся от события
		eventEmitter.$off("reload_tasks", this.reloadTasksAll);
		eventEmitter.$off("ResetFilter", this.ResetDopFilter);
	},
};
</script>
<style scoped>
	.tasks-page >>> .btn-primary.active {background-color:#01B0E0!important;}
	.tasks-page .actionBar {
		justify-content: space-between;
		padding-left: 15px;
		flex-wrap: wrap;
	}
	.tasks-page .actionBar .btn-group {
		height: 32px;
	}
	.tasks-page .createTaskBtn > button {
		margin-top: 0px;
	}
	.btn:not(.btn-icon) .tim-icons, .navbar .navbar-nav > a.btn:not(.btn-icon) .tim-icons {
    position: relative;
	top: -1px;
	}
	.filterbutton {
		margin-right: 15px;
	}
	/*.tasks-page >>> .bootstrap-switch {width: 135px!important;}*/

	/*.tasks-page >>> .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {margin-left: -35px!important;}*/

	.tasks-page >>> .bootstrap-switch {width: 200px!important;}

	.tasks-page >>> .bootstrap-switch .bootstrap-switch-container {width: 100%!important;}

	@media (max-width: 398px) {
		/*
		.tasks-page .createTaskBtn > button {
			margin-top: 8px;
		}
		.filterbutton {margin-top: 8px; }*/
	}
	@media (max-width: 426px) {
		.tasks-page .btn-group .btn {
			padding: 4px 15px;
		}
		
	}	

	.white-content .card:not(.card-white) >>>  .fc-dayGrid-view .fc-day-number {color: #5C70A4!important;}
	
</style>
